export default "__VITE_ASSET__BIx$tOc0__"